export default __webpack_public_path__ + "static/media/banner-tablet-bg-darkblue-template.40490d1f.svg";